import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import VideoPlayer from '../../VideoPlayer/VideoPlayer';
import { HighlightVideoPlayerWrapper, HighlightVideoHeadlineWrapper, HeadlineTitleWrapper, HeadlineDescriptionWrapper } from '../HighlightsPlaylist.style';
import Share from '../../Share/Share';

const HighlightVideoPlayer = ({
    highlight,
    highlightList,
    enableAutoPlay,
    onMetaDataLoaded,
    extendedDisplay,
    setPlayerWrapper,
    handlers,
    mute
}) => {
    const videoPlayerProps = useMemo(() => {
        const {
            title,
            description,
            duration,
            id,
            templateUrl,
            slug,
            playbacks
        } = highlight || {};
        return {
            title,
            description,
            duration,
            playbackContainerId: 'highlights-playback-container',
            id,
            templateUrl,
            slug,
            playbacks
        };
    }, [highlight]);

    const playlistPlayer = useMemo(() => {
        return (
            <VideoPlayer
                {...videoPlayerProps}
                setPlayerWrapper={setPlayerWrapper}
                mediaItemList={highlightList}
                mediaItem={highlight}
                onMetaDataLoaded={onMetaDataLoaded}
                autoPlay={enableAutoPlay}
                playerContext={'Video Tab'}
                handlers={handlers}
                mute={mute}
                showMetaInfo
            />
        );
    }, [highlight, videoPlayerProps, highlightList, setPlayerWrapper, mute, onMetaDataLoaded, enableAutoPlay, handlers]);

    const hTitle = highlight?.title;

    const trackingConfig = useMemo(() => {
        return {
            componentName: ['Video', 'Highlight Card Share Button'],
            text: hTitle
        };
    }, [hTitle]);

    return (
        <HighlightVideoPlayerWrapper>
            {playlistPlayer}
            <HighlightVideoHeadlineWrapper $extendedDisplay={extendedDisplay}>
                <HeadlineTitleWrapper>
                    {hTitle}
                </HeadlineTitleWrapper>
                <HeadlineDescriptionWrapper>{highlight?.description}</HeadlineDescriptionWrapper>
                {highlight?.shareUrl && (
                    <Share
                        size={'xs'}
                        url={highlight?.shareUrl}
                        headline={hTitle}
                        openDirection={'down'}
                        trackingConfig={trackingConfig}
                    />
                )}
            </HighlightVideoHeadlineWrapper>
        </HighlightVideoPlayerWrapper>
    );
};

HighlightVideoPlayer.propTypes = {
    highlight: PropTypes.object,
    highlightList: PropTypes.array,
    enableAutoPlay: PropTypes.bool,
    extendedDisplay: PropTypes.bool,
    onMetaDataLoaded: PropTypes.func,
    handlers: PropTypes.object,
    setPlayerWrapper: PropTypes.func,
    mute: PropTypes.bool
};

export default HighlightVideoPlayer;
